require('./CustomModal.scss');
require('../../DashboardModal/DashboardModal.scss');

const React = require('react');
const {PropTypes} = React;
const {Dialog} = require('material-ui');

const CustomModal = React.createClass({displayName: "CustomModal",

    propTypes: {
        actions: PropTypes.array,
        boolean: PropTypes.isVisible,
        customClass: PropTypes.string,
        customStyle: PropTypes.object,
        title: PropTypes.string
    },

    /**
     * The internal reference to modal element.
     */
    _el: null,

    componentDidMount() {
        this._changeVisible(this.props);
    },

    componentWillReceiveProps(nextProps) {
        this._changeVisible(nextProps);
    },

    _changeVisible(nextProps) {
        if (nextProps) {
            if (nextProps.isVisible) {
                this._el.show();
            } else {
                this._el.dismiss();
            }
        }
    },

    _getRef(el) {
        this._el = el;
    },

    render() {
        const {title, actions, customClass, customStyle} = this.props;
        return (
            React.createElement("div", {className: "bp-custom-modal modal-order"}, 
                React.createElement(Dialog, {
                    ref: this._getRef, 
                    title: title, 
                    actions: actions, 
                    hideToolbarYearChange: false, 
                    autoScrollBodyContent: true, 
                    autoDetectWindowHeight: true, 
                    modal: true, 
                    contentStyle: customStyle, 
                    contentClassName: `dashboard-modal-content bp-custom-modal__content ${customClass ? ' ' + customClass : ''}`
                }, 
                     this.props.children
                )
            )
        );
    }
});


module.exports = CustomModal;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/CustomModal/CustomModal.js
 **/